import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";

const TopCard = ({
  title,
  content,
  icon,
  link,
  data_for,
  toolTipTitle
}) => {
  return (
    <div className="card widget-flat">
      <ReactTooltip
        id={data_for}
        place="top"
        effect="solid"
        type="info"
      >
        {toolTipTitle}
      </ReactTooltip>
      <div className="card-body">
        <div className="float-right">
          <i className={`${icon}`}></i>
        </div>
        <h5 className="text-muted font-weight-normal mt-0">
          <Link
            className="text-muted font-weight-normal mt-0"
            to={`${link}`}
            data-tip
            data-for={data_for}
          >
            {title}
          </Link>
        </h5>

        <Link
          className="text-dark font-weight-normal mt-0"
          to={`${link}`}
        >
          <h3 className="mt-3 mb-3">{content}</h3>
        </Link>
      </div>
    </div>
  );
};

TopCard.propTypes = {
  link: PropTypes.any,
  icon: PropTypes.any,
  title: PropTypes.string.isRequired,
  toolTipTitle: PropTypes.string.isRequired,
  data_for: PropTypes.string.isRequired,
  content: PropTypes.any.isRequired
};

export default TopCard;
